/*globals $:false*/
import ClipboardP from './presenter/recordm.clipboard.js';

import InstanceM from './model/recordm.model.entity.instance.js';
import InstanceP from './presenter/recordm.presenter.instance.js';

import { sprintf } from 'sprintf-js';

import tmpl from './templates/instance-container.dot';

import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

/**
 * args:
 * * `core`: cob.app
 * * `opts`: accepts:
 *       * `container`: an element that should contain the UI
 *       * `exit`: a callback called when the user has asked to exit the Instance creation
 *       * `afterSave`: a callback called after saving the instance
 *       * `exitLabel`: a localize key to be used on the exit (back) button
 */
var InstanceDuplicate = function(core, opts) {

    var _$mainContainer,
        _instanceP;

    var _instanceId,
        _instanceM;

    const _opts = {...opts};

    var _loadingKey = core.getLoadingKey();

    var _loadInstanceForDuplication = function(instanceId, instanceLoadLatch) {

        core.showLoading(_loadingKey, "_loadInstanceForDuplication");

        InstanceM.get(core, instanceId, {
            forceReload: true,

            success: function(instanceM) {
                _instanceM = instanceM.getDuplicate(core);

                instanceLoadLatch.countDown("instance:duplicate-of:" + instanceM.data.id);

                core.hideLoading(_loadingKey, "_loadInstanceForDuplication.success");
            },

            error: function(status) {
                if (status === 404) {
                    ui.notification.showCustom(
                        'error',
                        sprintf(core.translateString("recordm.instances", "msgs.error-title"), instanceId),
                        core.translateString("recordm.instances", "msgs.not-found")
                    );
                }

                core.hideLoading(_loadingKey, "_loadInstanceForDuplication.error");
            }
        });
    };

    var _start = function(instanceId) {
        _instanceId = instanceId || _instanceId;

        // Creating a latch because the code becomes more
        // simple to read. This will happen after the domain has been loaded
        // successfully.
        var duplicateInstanceLatch = new utils.CountdownLatch(1, function() {

            core.showLoading(_loadingKey, "duplicateInstanceLatch");

            _$mainContainer = $(tmpl({
                containerClass: "js-instance-duplicate-container"
            }));

            core.translate("recordm.instances", _$mainContainer);

            if(_opts.container){
                window.console.debug('JB', 'appending to container')
                _$mainContainer.appendTo(_opts.container);
            } else {
                _$mainContainer.appendTo('#'+core.getAppInstanceId());
            }
            _$mainContainer.removeClass("hidden");

            var _clipboardP = new ClipboardP(core); //we won't use it but InstanceP needs one

            const _callbacks = {
                cancel: function(){
                    if(typeof _opts.exit == 'function') _opts.exit();
                    else core.navigateBack();
                },
                afterSave: function(){
                    if(typeof _opts.afterSave == 'function') _opts.afterSave();
                    else setTimeout(() => core.navigateBack(), 300);
                }
            };

            if (typeof _opts.afterSaveEdit == 'function') {
                _callbacks.afterSaveEdit = _opts.afterSaveEdit;
            }
            if (typeof _opts.afterSaveCreateNew == 'function') {
                _callbacks.afterSaveCreateNew = _opts.afterSaveCreateNew;
            }

            _instanceP = new InstanceP(core, _$mainContainer, _instanceM, _clipboardP,
                _callbacks,
                {
                    exitLabel: _opts.exitLabel
                }
            );
            _instanceP.init(true, true);

            core.hideLoading(_loadingKey, "duplicateInstanceLatch.done");
        });

        _loadInstanceForDuplication(_instanceId, duplicateInstanceLatch);

    };

    var _stop = function() {
        if (_instanceP) {
            _instanceP.destroy();
            _$mainContainer.remove();
        }
    };

    return {
        init: _start,
        pause: _stop,
        resume: _start,
        destroy: _stop
    };
};

export default InstanceDuplicate;
